<template>
  <div id="about">
    <div>
      <div class="poster">
        <img src="@/common/img/img1.d6056a76.jpg" alt="">
      </div>

      <div style="width: 1200px; margin: 0 auto;">
        <div style="display: flex; flex-wrap: wrap; justify-content: center;padding: 5px; box-sizing: border-box;">
          <el-button style="margin: 5px;background-color: #0a84ca; color: #fff;">企业介绍</el-button>
        </div>
        <div id="companyIntroduct" style="text-align: center;">
          <el-card style="margin: 0 auto;margin-top: 20px;width: 90%;text-align: left;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);border-radius: 4px;border: 1px solid #ebeef5; background-color: #fff;overflow: hidden; color: #303133; transition: .3s;">
            <div slot="header" style=" padding: 18px 20px; border-bottom: 1px solid #ebeef5; box-sizing: border-box;">
              <span style="font-size: 20px;">公司简介</span>
            </div>
            <div class="content">
              <div style="flex: 1;width: 40%;display: inline-block;">
                <video  id="bgvid" playsinline="" autoplay="autoplay" muted="muted" loop="loop" style="width: 95%;object-fit: contain;overflow-clip-margin: content-box; overflow: clip;">
                  <source  src="@/assets/video/company.mp4" type="video/mp4">
                </video>
              </div>
              <div style="background-color: #f7f7f7; padding: 15px; width: 56%; display: inline-block;">
                <p>
                  鄂尔多斯市安能检测检验有限公司（以下简称公司）成立于二○一七年，是一家检测能力较强、市场占有率真较大的检测检验机构，具有独立法人资格，注册资本1000万元，位于内蒙古自治区鄂尔多斯市东胜区金辉大厦5楼，办公区、实验区等场所共计2000多平方米；同时配备了四十余名专业的检测检验技术人员，其中包括注册安全工程师、高级工程师等数名，专业的检测设备一千台/套，专业检测车辆十余辆。
                </p>
                <p>
                  目前公司主要检测范围矿用仪器仪表检测检验、矿用电气设备检测检验、矿用通风设备检测检验、无陨探伤检测检验、矿用车辆检测检验等，几乎覆盖了矿山在用设备所有名录；设有检测检验部、仪器仪表实验室、综合部、业务部、质量技术部、财务部6个部门，从过程到结果，从源头到终端，全方位监管服务。
                </p>
                <p>
                  公司依据AQ/T 8006-2018《安全生产检测检验能力的通用要求》、AQ/T 8012-2022《安全生产检测检验机构诚信建设规范》要求，按照资质认定和实验室认可等规范，结合公司实际情况，建立并不断完善管理体系确保持续有效运行，达到法定检测检验机构要求，更好地为企业的安全生产服务。
                </p>
                <p>
                  我们把安全检测质量、速度等服务放在第一位，坚守安全底线，切实推行全面质量管理，坚持“诚信第一、质量第一、科学公正、优质服务”的服务准则。严格执行相关检测检验标准规范，保守客户的商业机密，恪守公正、严谨、精准、高效的质量方针,以科学、严谨的态度坚守职业道德，发挥检测检验机构应有的作用，为矿山安全生产工作做出积极的贡献。
                </p>
                </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.$store.state.el_.scrollTop = 0
    })
  }
}
</script>

<style lang='less' scoped>
  @media screen and (max-width: 1200px) {
    #about .container {
      width: 100%;
    }
  }
  @media screen and (min-width: 1200px) {
    #about .container {
      width: 1200px;
      margin: 0 auto;
    }
  }
  @media screen and (min-width: 768px) {
    #about {

    }
  }
  #about {
    text-align: center;

    .poster {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .container {
      // margin-top: 20px;

      .btnContent {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 5px;
        box-sizing: border-box;

        .el-button {
          margin: 5px;
        }
      }
    }
    ul {
      padding: 0;
    }
    .isShow {
      background-color: rgb(10, 132, 202);
      color: #fff;
    }
  }
</style>
